import {
  IsNotEmpty,
  IsIn,
  IsArray,
  ValidateNested,
  IsOptional,
  IsNumber,
  IsBoolean,
} from "class-validator";
import { Type } from "class-transformer";

import { Constants } from "@eagerdog/constants";

import { IObedienceScore } from "./obedience-score.interface";
import { ElementDeductionsDto } from "./element-deductions.dto";

export class ObedienceScoreDto implements IObedienceScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsOptional()
  result_reason?: string;

  // @IsNotEmpty()
  // @IsNumber()
  // deductions: number;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ElementDeductionsDto)
  element_deductions?: ElementDeductionsDto[];

  // UKC Obedience
  @IsOptional()
  @IsNumber()
  extra_deductions?: number;

  @IsOptional()
  @IsArray()
  extra_deduction_reasons?: string[]; // Constants.ukc_deduction_reasons

  @IsOptional()
  @IsArray()
  non_qualifying_reasons?: string[]; // Constants.ukc_non_qualifying_reasons

  @IsOptional()
  other_error?: string;

  @IsOptional()
  @IsBoolean()
  total_deductions_only?: boolean;

  @IsOptional()
  @IsNumber()
  total_deductions?: number;

  // C-WAGS Obedience - total score (not deductions)
  @IsOptional()
  @IsNumber()
  total_score?: number;

  @IsOptional()
  @IsBoolean()
  excluded_from_placement?: boolean;
}
